export default {
  message: {
    details: 'Dettagli',
    back: 'Indietro',
    exportDataTitle: 'Scarica gli elenchi come file Excel',
    mobile_phone: 'Numero di telefono (cellulare)',
    sales_representative: 'Rappresentante commerciale',
    commitment_letter_accept: 'Lettera di impegno accettata',
    iban_number: 'numero IBAN',
    without_supplier: 'Senza fornitore',
    price_in_euro: 'Prezzo al dettaglio',
    is_default: 'Predefinito',
    attribute_option: 'Opzione attributo',
    image: 'Immagine',
    show_stats_user: 'Statistiche del negozio - UTENTI',
    shopUserStats: {
      pageTitle: 'Statistiche shop – Utenti',
      viewList: 'Visualizza statistiche',
      perPage: 'Righe per pagina',
      searchPlaceholder: 'Cerca per email, numero cliente, azienda…',
      paginationSummary: '{from}–{to} di {total} (pagina {page} / {lastPage})',
      loadError: 'Impossibile caricare le statistiche utenti shop.',
      exporting: 'Esportazione…',
      exportDone: 'Esportazione completata ({rows} righe).',
      exportFailed: 'Esportazione fallita.',
      exportPanel: {
        title: 'Export Excel',
        refreshStatus: 'Aggiorna stato',
        lastExport: 'Ultimo export',
        lastPoint: 'Ultimo punto',
        rowCount: 'Righe',
        stateReadyFresh: 'Dati aggiornati. Puoi scaricare l’export.',
        stateReadyStale:
          'L’import punti è più recente dell’ultimo export. Scarica il file precedente o attendi il prossimo ciclo (ogni 15 min).',
        stateWaitingRefresh: 'Generazione del nuovo file…',
        stateNoFile: 'Il file di export non è ancora disponibile.',
        firstFileEta: 'Primo file previsto intorno alle {eta}.',
        downloadExcel: 'Scarica Excel',
        formatLabel: 'Formato',
        formatXlsx: 'XLSX (.xlsx)',
        formatXls: 'XLS (.xls)',
        downloadLastFile: 'Scarica ultimo file',
        waitForUpdate: 'Attendi aggiornamento',
        refreshInProgress: 'Aggiornamento in corso…',
        downloadSuccess: 'File scaricato.',
        downloadUpdatedSuccess: 'File aggiornato scaricato.',
        downloadRunning: 'Aggiornamento in corso, riprova tra poco.',
        downloadNotReady: 'File non ancora pronto. Prossimo tentativo intorno alle {eta}.',
        waitTimeout: 'Timeout in attesa del nuovo export.',
        statusLoadFailed: 'Impossibile caricare lo stato export.',
        staleConfirmTitle: 'Scaricare un export più vecchio?',
        staleConfirmBody: 'Il file è del {exportAt}, i punti sono stati aggiornati il {pointAt}. Continuare?'
      }
    },
    is_manual_order: 'È un ordine manuale',
    supplier_id: 'Identificativo del fornitore',
    vendor_id: 'Identificativo del produttore',
    archive_at: 'Archivio',
    exported_bridgestone: 'Esporta Bridgestone',
    exported_engelbert: 'Esporta Engelbert Strauss',
    exported_prime: 'Esporta PremiumDirect',
    exported_other: 'Altri esportarono',
    product_variant_id: 'ID variante prodotto',
    cancelled_at: 'Annullato alle',
    shipped_at: 'La spedizione avviene il',
    product_id: 'Codice prodotto',
    quantity: 'Folla',
    qty: 'Folla',
    action_text: "Testo dell'URL",
    action_url: 'URL',
    token: 'UUID',
    marketing_option: 'Opzione di marketing',
    parent_id: 'ID genitore',
    parent_name: 'Nome del genitore',
    approval_id: 'ID di approvazione',
    wholesaler_id: 'Codice grossista',
    cart_id: 'ID del carrello',
    order_date: "Data dell'ordine",
    order_number: "Numero d'ordine",
    accept_date: 'Accetta data',
    wholesaler_dealer_id: 'ID rivenditore grossista',
    dealer_id: 'ID del rivenditore',
    is_partial_delivery: 'È la consegna parziale',
    order_completed: 'ordine completato',
    order_cancelled: 'ordine cancellato',
    date_delivery: 'data di consegna',
    published: 'Pubblicare',
    properties: 'Caratteristiche',
    group: 'Nome del gruppo',
    gka: 'GKA',
    publish_at: 'Pubblicare',
    video: 'URL del video',
    training_id: 'ID della formazione',
    correct: 'È giusto?',
    question_id: 'ID della domanda',
    body: 'Contenuti',
    size: 'Dimensione del testo',
    platform: 'sistema operativo',
    is_added: 'Booster attivi',
    numberOfSetsOfSeasonalTiresBudget: "stoccaggio all'anno",
    distributionWinter: 'inverno',
    distributionSummer: 'Estate',
    overEighteenInch: 'Di cui ≥ 18 pollici (in %)',
    tireSalesNumber: "Vendite di pneumatici all'anno ca.",
    distributionAll: 'Tutto seizoen',
    budgetPremium: 'Premio',
    postal_code: 'Codice Postale',
    legalForm: 'forma giuridica',
    budgetMid: 'Metà',
    budgetLow: 'bilancio',
    group_id: 'Identificativo del gruppo',
    website: 'sito web',
    customer_number: 'Numero cliente',
    user_id: 'ID utente',
    browser: 'Webbprogramma di navigazione in reterowser',
    ip: 'indirizzo IP',
    email_verified_at: 'E-mail confermata a',
    last_login: 'Ultimo accesso',
    deleted_at: 'cancellato il',
    is_active: 'È attivo?',
    old: 'Vecchio',
    selectBooster: 'Seleziona il potenziamento',
    activeBooster: 'Booster attivo',
    activeBoosterText: "Vuoi abilitare un booster attivo per l'utente?",
    activeBoostersOne: 'Abiliterai questo booster per ogni utente?',
    activeBoostersSalesDataWarning:
      'Assicurati che i dati di vendita a cui stai per applicare il booster siano definitivi e non verranno modificati in futuro. In caso contrario, potrebbero verificarsi discrepanze nei calcoli. Questa azione non può essere annullata.',
    sum: 'Summe',
    boosterOnTop: 'Booster-Punkte (zusätzlich)',
    relevantBoosterPoints: 'Relevante Punkte für Booster',
    totalBefore: 'Gesamtpunktzahl vorher',
    standardPoints: 'Standardpunkte',
    standard: 'Standard',
    boosterPoints: 'Punti booster',
    allPoints: 'Tutti i punti',
    pointsByUser: 'Scarica punti per utente',
    pointsByGroup: 'Scarica punti per gruppo',
    allKickbacks: 'Tutti i kickback',
    kickbackByUser: 'Scarica kickback per utente',
    kickbackByGroup: 'Scarica kickback per gruppo',
    pointsImportFileInfo: "Nel file, la colonna 1 deve essere l'email e la colonna 2 i punti.",
    pointsImportHeaderInfo:
      'La prima riga deve contenere le intestazioni: Email e Points. I dati devono iniziare dalla seconda riga.',
    pointsImportValueInfo:
      'I valori dei punti nel file devono essere positivi o negativi. Usa valori positivi per aggiungere punti e valori negativi per sottrarre punti.',
    pointsImportTitle: 'Importazione punti da file Excel',
    pointsImportFailed: 'Importazione non riuscita',
    pointsImportSummaryTitle: "Riepilogo dell'importazione",
    pointsImportProcessed: 'Elaborati',
    pointsImportInvalidFile: 'Sono consentiti solo file Excel (.xlsx, .xls).',
    pointsImportPreviewLoading: "Preparazione dell'anteprima del file...",
    pointsImportPreviewCount: 'Visualizzazione di {shown} righe su {count} dal file.',
    pointsImportPreviewEmpty: 'Il file selezionato non contiene righe da importare.',
    pointsImportPreviewError: 'Impossibile leggere il file Excel selezionato.',
    pointsImportDateInfo:
      'La data selezionata sarà usata come data di creazione dei punti sul conto utente. Possono essere anche punti riferiti a periodi passati.',
    loginAs: 'Accedi come utente',
    positionX: 'posizione x',
    positionY: 'posizione y',
    textSize: 'Dimensione del testo',
    text: 'testo',
    publish: 'Pubblicare',
    certificate: 'certificato',
    certificatePdf: {
      title: 'CERTIFICATO',
      tookPartInCourse: 'ha partecipato al corso:',
      courseDetails: 'Dettagli del corso'
    },
    event: 'Evento',
    remove_cs_number: 'Sei sicuro di voler eliminare il numero cliente {customerNumber} ({wholesaler})?',
    keep_previous_year_points: 'Mantieni i punti degli anni precedenti dopo l’eliminazione del numero cliente',
    keep_previous_year_points_warning:
      'If you select this option, deleting the customer number will remove only points from the current year. Points from previous years will remain, so older balances and reports may still include data linked to this customer number. Select this only if you want to keep past years unchanged.',
    remove_order: "Sei sicuro di voler eliminare l'ordine?",
    is_internal: "L'utente è interno?",
    selectAddressBtn: "scegli l'indirizzo",
    currentBasket: 'Carrello attuale',
    loginEmail: 'Registrazione',
    tenantEmailType: 'Tipo di e-mail',
    tenantEmailAddNew: 'Aggiungi una nuova e-mail',
    tenantEmailTypeFinancial: 'Per informazioni finanziarie (es. dettaglio bonus)',
    tenantEmailTypeMarketing: 'Per comunicazioni marketing Bridgestone Plus (es. promozioni/newsletter)',
    open_new_tab: 'Apri in una nuova scheda?',
    newTabLabel: 'Nuova scheda',
    file: 'file',
    company_name: 'azienda',
    partner_name: 'Referente',
    dealer: 'Rivenditore',
    boosterImport: {
      label: 'File CSV.'
    },
    created_at: 'Creato',
    done_by: 'Eseguito da',
    authors: 'Eseguito da',
    changes: 'Modifiche',
    modified_user: 'Utente interessato',
    modified_users: 'Utenti interessati',
    full_text_search: 'Ricerca nel testo completo',
    logs: 'Registri',
    activity: 'attività',
    booster_create: 'Crea booster',
    booster_brands: 'Marchi',
    booster_motor: 'Moto',
    booster_message_title: 'Titolo del messaggio',
    booster_delete_points: 'Elimina punti',
    booster_delete_points_confirm: 'Sei sicuro di voler eliminare questi punti booster? Questa azione non può essere annullata.',
    booster_wholesaler: 'Grossista',
    booster_products: 'Nomi dei prodotti',
    booster_customers: 'Numeri dei clienti',
    booster_saison: 'stagione',
    booster_name: 'Cognome',
    booster_factor: 'fattore',
    booster_from: 'tempo di esecuzione di',
    booster_to: 'Durata fino a',
    boosterList: {
      seasons: 'Stagioni',
      usersAmount: 'Numero di utenti',
      factor: 'Fattore',
      calculateBoosters: 'Calcola booster',
      calculateBoostersConfirmTitle: 'Calcolare i booster?',
      calculateBoostersConfirm:
        'Verrà avviato il calcolo dei punti booster per gli utenti corrispondenti in base a questa configurazione. Il processo può richiedere del tempo. I risultati compariranno nell’anteprima booster, dove potrai rivederli e accettarli oppure eliminare i punti calcolati. Al termine del calcolo, la modifica di questo booster potrebbe non essere più possibile. Vuoi continuare?',
      showAll: 'Mostra tutto (+{count})',
      showLess: 'Mostra meno'
    },
    booster_tires: 'Dimensioni dei pneumatici',
    booster_ipcs: 'IPC',
    boosterIpcsImport: {
      button: 'Carica IPC da Excel',
      hint: 'Colonna A, file .xlsx/.xls',
      emptySheet: 'Foglio vuoto.',
      emptyColumn: 'Nessun dato nella colonna A.',
      spacesError: 'IPC non validi (contengono spazi): {items}',
      invalidFormatError: 'Formato IPC non valido (solo numeri): {items}',
      requestValidationError: 'Errore di validazione della richiesta.',
      unknownError: 'IPC sconosciuti: {items}',
      success: 'IPC importati: {count}',
      readError: 'Impossibile leggere il file IPC.'
    },
    select: 'Si prega di scegliere',
    booking: 'biglietteria',
    credit: 'Credito',
    deduction: 'Deduzione',
    preview: 'anteprima',
    subject: 'Per quanto riguarda',
    customerNumber: 'Numero cliente',
    search: 'Cercare',
    customer_nr_name: 'Numero/nome del cliente',
    selectAll: 'seleziona tutto',
    deselectAll: 'Deseleziona tutto',
    generateReport: {
      selectAll: 'Seleziona tutto',
      reset: 'Reimposta',
      loadingInfo: 'Generazione report in corso, attendere...',
      generate: 'Genera',
      validation: {
        distributorRequired: 'Seleziona almeno un distributore.'
      },
      personal_data: {
        title: 'Dati personali',
        email: 'Email',
        salutation: 'Saluto',
        first_name: 'Nome',
        last_name: 'Cognome',
        job_position: 'Ruolo'
      },
      shipping_address: {
        title: 'Indirizzo di consegna',
        company: 'Azienda',
        street: 'Via',
        postal_code: 'CAP',
        mobile_phone: 'Telefono mobile',
        iban_number: 'IBAN',
        vat: 'Partita IVA',
        city: 'Città'
      },
      operating_data: {
        title: 'Dati operativi',
        customer_number: 'Numero cliente',
        group: 'Gruppo',
        first_registration: 'Prima registrazione',
        last_login: 'Ultimo accesso',
        tires_per_year: 'Vendite pneumatici per anno',
        over_18_inch: 'Oltre 18 pollici',
        premium: 'Premium',
        middle: 'Medio',
        summer: 'Estate',
        winter: 'Inverno',
        all_season: 'Quattro stagioni',
        major: 'Marca'
      },
      calculated_data: {
        title: 'Dati calcolati',
        tireAmount: 'Quantità pneumatici',
        points: 'Punti',
        bonus: 'Bonus'
      },
      sales_structure: {
        title: 'Struttura commerciale',
        distributor: {
          title: 'Distributore'
        },
        sales_representative: {
          title: 'Rappresentante commerciale'
        },
        wholesaler: {
          title: 'Grossista'
        },
        dealer: {
          title: 'Rivenditore'
        }
      },
      meta: {
        title: 'Filtri',
        brand: {
          title: 'Marca',
          BS: 'BS',
          FS: 'FS'
        },
        year: {
          title: 'Anno'
        },
        calendarMonth: {
          title: 'Mese',
          january: 'Gennaio',
          february: 'Febbraio',
          march: 'Marzo',
          april: 'Aprile',
          may: 'Maggio',
          june: 'Giugno',
          july: 'Luglio',
          august: 'Agosto',
          september: 'Settembre',
          october: 'Ottobre',
          november: 'Novembre',
          december: 'Dicembre'
        }
      }
    },
    import: 'Importare',
    rows: 'Righe',
    message: 'Messaggio',
    articleNumber: 'codice articolo',
    inform_user: 'per informare i clienti',
    leaveComment: 'Lascia un commento qui',
    user_new: 'Nuovo utente',
    postalcode: 'Codice postale',
    city: 'posizionet',
    residence: 'È residenza',
    country: 'Paese',
    street: 'Via e numero civico',
    salutation: 'Saluto',
    suffix: 'Supplemento indirizzo',
    emailVerified: 'Email verificata il',
    registerAt: 'Registrato il',
    phone: 'Telefono',
    optinAt: 'Accetta',
    fax: 'Fax',
    date: 'Data',
    optinToken: 'Token di adesione',
    language: 'Lingua',
    company: 'azienda',
    forename: 'Nome di battesimo',
    lastname: 'Cognome',
    title: 'titolo',
    subtitle: 'Sottotitolo',
    remove: 'Eliminare',
    actions: 'Azioni',
    userData: 'Dati utente',
    clientType: 'Tipo di cliente',
    carDealer: 'Rivenditore auto',
    tyreDealer: 'Rivenditore pneumatici',
    teamLkw: 'Team LKW',
    teamEmOtr: 'Team EM/OTR',
    teamFarmTractor: 'Team trattore agricolo',
    teamBandag: 'Team Bandag',
    chooseDots: 'Scegli..',
    both: 'Entrambi',
    contact_service: {
      is_main: 'Contatto principale?',
      direct: 'Diretto',
      indirect: 'Indiretto'
    },
    fileChoose: 'Scegli file',
    fileNoSelected: 'Nessun file selezionato',
    loadingFile: 'Caricamento del file...',
    only_points_payment: 'Pagamento solo in punti',
    column: 'Colonna',
    csvOnly: 'Sono consentiti solo file CSV.',
    milestoneUsers: {
      csvImportTitle: 'Import CSV',
      csvFormatHint: 'Formato CSV: <code>email,milestone</code> (intestazione opzionale)',
      importErrorsTitle: 'Errori di importazione',
      errorLine: 'Riga {line}: {message}',
      importFinished: 'Import CSV completato.'
    },
    kickbackPayoutReady: "Modulo pronto per l'invio. File selezionato:",
    kickbackPayoutCsvInstruction:
      'Il file CSV deve contenere due colonne: la prima con l’email, la seconda con il valore del bonus in EUR.',
    kickbackPayoutCsvHeaderInvalid:
      'Intestazione CSV non valida. La prima colonna deve essere Email, la seconda nel formato Bonus <numero> (es. Bonus 25).',
    kickbackPayoutCsvTwoColumnsOnly: 'Il CSV deve contenere esattamente due colonne: Email e numero.',
    kickbackPayoutCsvEmailNumberInvalid:
      'Dati CSV non validi. La prima colonna deve essere un indirizzo email, la seconda un numero.',
    kickbackPayoutCsvBonus: 'Bonus CSV',
    kickbackPayoutKickBackFeeSum: 'Somma kickback',
    kickbackPayoutYear: 'Anno',
    kickbackPayoutMissingEmails: 'Email mancanti:',
    kickbackPayoutCsvFile: 'CSV',
    kickbackPayoutCsvContent: 'Contenuto CSV',
    kickbackPayoutAllTranslationsRaw: 'Tutte le traduzioni (raw)',
    multiplicator: {
      goals: {
        loyal: 'Fedele',
        bronze: 'Bronzo',
        silver: 'Argento',
        gold: 'Oro',
        platinum: 'Platino'
      }
    },
    importSchemaNotLoaded: 'Lo schema di importazione non è caricato.',
    csvHeaderEmpty: 'L’intestazione CSV è vuota.',
    csvHeaderMismatch: 'Intestazione CSV non valida alla colonna {index}: previsto "{expected}", ottenuto "{actual}".',
    csvHeaderMismatchTitle: 'Intestazione CSV non valida',
    csvColumnCountMismatchTitle: 'Numero di colonne CSV non valido',
    csvColumnCountMismatch: 'Riga {row}: previste {expected} colonne, ottenute {actual}.',
    csvHeaderColumnCountMismatch: 'Riga di intestazione: previste {expected} colonne, ottenute {actual}.',
    step: 'Passo',
    profile: 'Profilo',
    addresses: 'Indirizzi',
    address: 'indirizzo',
    notAvailable: 'Attualmente non disponibile al momento',
    disabled: 'Disabilitato',
    archived: 'Archiviato',
    visible_not_allowed_to_buy: 'Visibile, non acquistabile',
    isDefault: 'Predefinito',
    data: 'Dati',
    importText: 'Seleziona un file da importare:',
    importSchemaInfo: "Il file CSV deve contenere i seguenti campi nell'ordine esatto indicato qui sotto.",
    importConfirm: "Controlla l'anteprima di importazione qui sotto. Vuoi procedere con l'importazione?",
    importWholesalerHint: 'Opzionale. Se selezionato, i numeri cliente dal CSV verranno assegnati a questo grossista.',
    importDownloadTemplate: 'Scarica modello CSV vuoto',
    importModalTitle: 'Importa utenti da CSV',
    importStepSetup: 'Configurazione',
    importStepPreview: 'Anteprima',
    importStepResult: 'Risultato',
    importStepHelper: 'Scarica il modello, inserisci i dati e carica il file CSV.',
    importContextTitle: 'Impostazioni importazione',
    importRowsInFile: '{count} righe nel file',
    importValidating: 'Validazione file...',
    importPreviewLoading: 'Caricamento anteprima...',
    importSubmitting: 'Importazione utenti...',
    importStatsSuccess: 'Successo',
    importStatsError: 'Errori',
    importStatsInfo: 'Info',
    importStatsOther: 'Altri',
    importShowSchema: 'Mostra schema colonne',
    importHideSchema: 'Nascondi schema colonne',
    importPreviewChangesCount: '{count} modifiche ai campi',
    importDropzoneTitle: 'Trascina qui il file CSV',
    importDropzoneHint: 'oppure clicca per scegliere un file',
    importSelectClientTypeForPreview:
      'Il file sembra valido ({count} righe). Seleziona il tipo cliente per caricare l’anteprima.',
    importFileValid: 'File convalidato con successo ({count} righe).',
    importLoadPreview: 'Carica anteprima',
    importPreviewFilterErrors: 'Errori',
    importPreviewRowError: 'Errore',
    importPreviewFailed: "Impossibile caricare l'anteprima di importazione.",
    importPreviewSummary: 'Riepilogo',
    importPreviewTotalRows: 'Righe totali',
    importPreviewNewUsers: 'Nuovi utenti',
    importPreviewUpdatedUsers: 'Utenti aggiornati',
    importPreviewSkippedRows: 'Righe saltate',
    importPreviewErrors: 'Errori',
    importPreviewNewCustomerGroups: 'Nuovi gruppi clienti',
    importPreviewNewStaffUsers: 'Nuovi agenti commerciali',
    importPreviewAction: 'Azione',
    importPreviewIncoming: 'In entrata',
    importPreviewCreates: 'Creazioni',
    importPreviewUpdates: 'Aggiornamenti',
    importPreviewFieldChanges: 'Modifiche ai campi',
    importPreviewFieldColumn: 'Campo',
    importPreviewCurrentValue: 'Attuale',
    importPreviewFromFile: 'Dal file',
    importPreviewAfterImport: 'Dopo importazione',
    importPreviewNewValue: 'Nuovo',
    importPreviewWillChange: 'Verrà modificato',
    importPreviewDiffersInFile: 'Differisce nel file',
    importPreviewOnlyWithChanges: 'Solo righe con modifiche',
    importPreviewFilterAll: 'Tutte le righe',
    importPreviewShowDetails: 'Dettagli',
    importPreviewBackToList: 'Torna alla lista',
    importPreviewHideDetails: 'Nascondi dettagli',
    importPreviewNoFilterResults: 'Nessuna riga corrisponde ai filtri selezionati.',
    importPreviewRowDetails: 'Dettagli riga',
    importPreviewPlannedChanges: 'Modifiche previste',
    importPreviewExistingData: 'Dati attuali nel sistema',
    importPreviewFullComparison: 'Confronto completo',
    importPreviewNoExistingData: 'Nessun dato esistente (nuovo utente).',
    importPreviewNoFieldDetails: 'Nessun dettaglio campo disponibile per questa riga.',
    importPreviewCustomerGroups: 'Gruppi clienti',
    importPreviewExistingCustomerGroups: 'Gruppi esistenti',
    importPreviewActionCreate: 'Crea',
    importPreviewActionUpdate: 'Aggiorna',
    importPreviewActionUnchanged: 'Invariato',
    importPreviewActionSkip: 'Salta',
    importPreviewNoCreates: 'Non verrà creato nulla di nuovo',
    importPreviewNoUpdates: 'Nessun campo verrà aggiornato',
    importPreviewNoRowDetails: 'Il riepilogo è disponibile, ma i dettagli delle righe non sono stati caricati.',
    importPreviewDuplicateInFile: 'Duplicato nel file',
    importSuccess: 'Importazione completata con successo',
    importErrors: 'Errori di importazione',
    upload: 'Caricamento',
    users: 'utente',
    permission: 'Giusto',
    save: 'Salva',
    saving: 'Salvataggio...',
    downloadOrderStats: 'Scarica le statistiche',
    downloadProductStats: 'Scarica le statistiche dei prodotti',
    category: 'categoria',
    order: 'Ordine',
    permissions: 'Giusto',
    edit_permissions_title: 'Modifica autorizzazioni',
    options: 'Opzioni',
    attributes: 'Attributi',
    add_attribute: 'Aggiungi attributi',
    login: 'Aggiungi attributi',
    logout: 'Disconnettersi',
    email: 'E-Mail',
    username: 'utente',
    filter: 'Filtro',
    name: 'Cognome',
    points: 'Punti',
    sku: 'SKU',
    count: 'Numero',
    action: 'azione',
    active: 'Attivo',
    activeLabel: 'Attivo',
    type: 'Tipo',
    status: 'Condizione',
    main: 'Prodotto principale',
    vendor: 'Produttore',
    supplier: 'fornitore',
    variant: 'Variante del prodotto',
    description: 'Descrizione',
    short_description: 'Breve descrizione',
    upload_text: "Caricamento dell'immagine del prodotto",
    product_new: 'Nuovo prodotto unico',
    product_new_variants: 'Prodotto nuova variante',
    training_new: 'Nuova formazione',
    btraining_new: 'Nuova formazione BS',
    images: 'Immagini',
    roles: 'rotolo',
    search_products: 'Ricerca prodotto',
    search_orders: 'Ordini di ricerca',
    search_type: 'Tipo di ricerca',
    hunter_new: 'Nuovo cacciatore',
    first_name: 'Nome di battesimo',
    last_name: 'Cognome',
    social_security_number: 'Numero di previdenza sociale',
    place_of_birth: 'Luogo di nascita',
    date_of_birth: 'Data di nascita',
    copy: 'copia',
    add_empty_variant: 'Aggiungi variante vuota',
    points_exporter_date_label: 'Date',
    start_date: 'Data inizio',
    end_date: 'Data fine',
    points_exporter_download_button: 'Download',
    points_exporter_users_with_available_points: 'Users with available points',
    menu: {
      customerGroup: {
        new: 'Nuovo gruppo clienti',
        list: 'Elenco gruppi clienti'
      },
      shopLimits: 'Shop limits',
      default_banners: 'Banner predefiniti',
      import_adex: 'Importazione di Adex',
      adex: 'Adex',
      logs: 'Registri',
      activities: 'attività',
      booster_setup: 'Imposta i booster',
      booster_list: 'elenco',
      customer: 'Clienti',
      'users-roles': 'Gestione utenti',
      roles: 'rotolo',
      booster: 'Ripetitore',
      cheques: 'Controlli e detrazioni',
      points: 'Gestione punti',
      users: 'utente',
      users_list: 'Lista degli utenti',
      milestone_users: 'Utenti milestone',
      shop_user_stats_list: 'Statistiche utenti shop',
      user_new: 'Nuovo utente',
      users_deleted: 'Utenti eliminati',
      perms: 'Giusto',
      'categorie di prodotti': 'Negozio di premi',
      categories: 'Categorie',
      categories_list: 'Elenco delle categorie',
      category_new: 'Nuova categoria',
      orders: 'Ordini',
      products: 'Prodotti',
      products_list: 'Elenco prodotti',
      product_new: 'Nuovo prodotto unico',
      product_new_variants: 'Prodotto nuova variante',
      attributes: 'Attributi',
      attributes_list: 'Elenco degli attributi',
      attribute_new: 'Nuovi attributi',
      options: 'Opzioni',
      options_list: 'Elenco delle opzioni',
      options_new: 'Nuova opzione',
      vendors: 'Produttore',
      vendors_list: 'Elenco dei produttori',
      vendor_new: 'Nuovo produttore',
      suppliers: 'fornitori',
      suppliers_list: 'Elenco fornitori',
      supplier_new: 'Nuovo fornitore',
      sliders: 'Cursore principale del teaser',
      sliders_list: 'elenco',
      slider_new: 'Nuovo cursore principale del teaser',
      featured: 'Prodotti teaser',
      commands: 'Comandi',
      command_ipc: 'IPC',
      command_users: 'Importa utenti',
      'trainings-schulungen': 'Formazione e istruzione',
      trainings: 'Formazione in linea',
      trainings_list: 'elenco',
      training_new: 'Aggiungere nuova',
      btrainings: 'Formazione da sballo',
      btrainings_list: 'elenco',
      btraining_new: 'Aggiungere nuova',
      management: 'Gestione dei contenuti',
      textpages: 'Pagine di testo',
      textpages_list: 'elenco',
      text_page_new: 'Aggiungere nuova',
      marketing_consents: 'Consensi marketing',
      marketing_consents_list: 'Elenco consensi',
      marketing_consents_edit: 'Modifica consenso',
      settings: 'Responsabile delle notizie',
      messages: 'Crea messaggi',
      messages_list: 'elenco',
      messages_new: 'Aggiungere nuova',
      threads: 'Configura le email automatiche',
      requests: 'Richieste degli utenti',
      product_trainings_request: 'Formazione in linea',
      bridgestone_courses_request: 'Formazione da sballo',
      external_trainings_request: 'Formazione esterna',
      hunter_request: 'Cacciatore',
      investments_request: 'Sostegno agli investimenti',
      news_feed: 'notizia',
      news_feed_list: 'elenco',
      news_feed_new: 'Aggiungere nuova',
      salespromotions: 'Promozione delle vendite',
      promotions: 'Promozioni',
      promotions_list: 'elenco',
      promotions_new: 'Nuovo',
      imported_products: 'Prodotti importati',
      ipcs_list: 'Elenco IPC',
      hunter_list: 'elenco',
      hunters: 'Cacciatore',
      hunter_new: 'Nuovo cacciatore',
      groups: 'gruppi',
      groups_list: 'Elenco dei gruppi',
      parent_attributes: 'Attributi principali',
      group_new: 'Nuovo gruppo',
      history: 'Cronologia degli accessi',
      history_list: 'Cronologia degli accessi',
      prices: 'Pricat',
      prices_list: 'elenco',
      price_new: 'nuovo Pricat',
      price_categories: 'Listino prezzi',
      price_categories_list: 'elenco',
      price_categories_new: 'Nuovi listini prezzi',
      inactive_users: 'Nuove registrazioni<br/>rilascio',
      customer_numbers_to_approve: 'Nuove immatricolazioni<br/>senza numero',
      complaints: 'Modulo di reclamo',
      orders_list: 'elenco',
      orders_new: 'Nuovi ordini',
      points_list: 'Elenco punti',
      kickback_list: 'Commissione di contraccolpo',
      kickback_payout: 'Pagamento kickback',
      booster_preview: 'anteprima',
      frontend_menu: 'Menù frontend',
      frontend_menu_list: 'elenco',
      frontend_menu_new: 'Nuovo',
      'customer-groups': 'Gruppi clienti',
      'customer-groups-list': 'Elenco gruppi clienti',
      'customer-groups-new': 'Nuovo gruppo clienti',
      'customer-groups-edit': 'Modifica gruppo clienti',
      customer_group_new: 'Nuovo gruppo clienti',
      mediapages: 'Pacchetti multimediali',
      mediapages_list: 'elenco',
      media_page_new: 'Nuovo',
      uberall_request: 'Ovunque',
      history_hour: 'Tempi di registrazione',
      wholesaler_management: 'Gestione grossisti',
      in_active_cs_nr: 'Numeri disattivati',
      mediapages_file_list: 'elenco dei file',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'Liste',
      brochure_prices: 'Broschüren & Preislisten',
      brochure_prices_new: 'Neu',
      brochure_file_list: 'Liste',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Sondaggio clienti Hello',
      apps: 'App',
      apps_list: 'Elenco app',
      dealer_apps: 'App concessionario',
      about: 'Pagina Chi siamo',
      about_list: 'Elenco',
      about_new: 'Nuovo',
      about_edit: 'Modifica',
      contact_service: 'Servizio contatti',
      contact_service_list: 'Elenco',
      contact_service_new: 'Nuovo',
      contact_service_edit: 'Modifica',
      points_exporter: 'Points Exporter',
      points_exporter_export: 'Export',
      customer_numbers_assistant: 'Assistente numeri cliente'
    },
    breadcrumb: {
      shopLimits: 'Shop limits',
      customer_numbers_assistant: 'Assistente numeri cliente',
      in_active_cs_nr: 'Numeri disattivati',
      default_banners: 'Banner predefiniti',
      import_adex: 'Importazione di Adex',
      adex: 'Adex',
      activities: 'attività',
      booster_setup: 'Imposta i booster',
      booster_list: 'elenco',
      customer: 'Clienti',
      booster: 'Ripetitore',
      booster_edit: 'Modifica',
      cheques: 'Controlli e detrazioni',
      user_edit: 'Modifica utente',
      users: 'utente',
      user: 'utente',
      vendors: 'Produttore',
      vendor_new: 'Nuovo produttore',
      suppliers: 'fornitori',
      supplier_new: 'nuovo fornitore',
      home: 'Casa',
      perms: 'Giusto',
      roles: 'rotolo',
      roles_list: 'elenco',
      dashboard: 'Pannello di controllo',
      orders: 'Ordini',
      orders_edit: 'Modifica il tuo ordine',
      orders_view: 'Ordine',
      orders_list: 'elenco',
      salespromotions: 'Promozione delle vendite',
      promotions: 'Promozioni',
      promotions_list: 'elenco',
      promotions_new: 'Nuovo',
      promotions_edit: 'Modifica',
      salespromotions_list: 'elenco',
      salespromotions_view: 'visualizzazione',
      categories: 'Categorie',
      categories_list: 'elenco',
      role: 'ruolo',
      category: 'Categorie',
      marketing_consents: 'Consensi marketing',
      marketing_consents_list: 'Elenco consensi',
      marketing_consents_edit: 'Modifica consenso',
      products: 'Prodotti',
      products_list: 'elenco',
      product: 'Prodotto',
      product_category: 'Prodotti di categoria',
      product_new: 'Nuovo prodotto unico',
      product_new_variants: 'Prodotto nuova variante',
      product_variants: 'Prodotto variante',
      attributes: 'Attributi',
      attributes_list: 'elenco',
      attribute: 'attributo',
      category_new: 'Nuova categoria',
      attribute_edit: 'Modifica attributo',
      options_new: 'Nuova opzione',
      options: 'Opzioni',
      options_list: 'elenco',
      options_edit: 'Modifica opzione',
      userEdit: 'Modifica utente',
      users_list: 'elenco',
      milestone_users: 'Utenti milestone',
      shop_user_stats_list: 'Statistiche utenti shop',
      users_deleted: 'Utenti eliminati',
      vendor_edit: 'Modifica produttore',
      vendors_list: 'elenco',
      supplier_edit: 'Modifica fornitore',
      suppliers_list: 'Elenco fornitori',
      user_new: 'Nuovo utente',
      trainings: 'Formazione',
      trainings_list: 'elenco',
      btrainings: 'Formazione in linea',
      btrainings_list: 'elenco',
      btraining: 'Formazione in linea',
      training_new: 'Nuova formazione',
      btraining_new: 'Nuova formazione BS',
      training_edit: 'Modifica formazione',
      training: 'formazione',
      command_ipc: 'IPC',
      sliders: 'Cursore principale del teaser',
      sliders_list: 'elenco',
      slider_new: 'Nuovo cursore principale del teaser',
      slider: 'Modifica il dispositivo di scorrimento del teaser principale',
      command_users: 'Importa utenti',
      textpages: 'Pagine di testo',
      text_page_new: 'Nuova pagina di testo',
      textpage: 'Pagine di testo',
      textpages_list: 'elenco',
      messages: 'Notizia',
      messages_list: 'elenco',
      messages_new: 'Nuovo messaggio',
      messages_edit: 'modificare il messaggio',
      threads: 'Per quanto riguarda',
      featured: 'Prodotti teaser',
      attribute_new: 'Nuovo attributo',
      product_trainings_request: 'Richieste di formazione online',
      bridgestone_courses_request: 'Richieste di formazione Bridgestone',
      external_trainings_request: 'Richieste di formazione esterna',
      hunter_request: 'Cacciatore',
      investments_request: 'Sostegno agli investimenti',
      news_feed: 'notizia',
      news_feed_list: 'elenco',
      news_feed_new: 'Nuovo feed di notizie',
      news_feed_edit: 'Modifica il feed di notizie',
      news_feed_slider: 'Nuovo dispositivo di scorrimento del feed di notizie',
      content: 'Contenuti',
      imported_products: 'Prodotti importati',
      ipcs_list: 'Elenco IPC',
      hunter_list: 'elenco',
      hunters: 'Cacciatore',
      hunter_new: 'Nuovo cacciatore',
      hunter_edit: 'Modifica Cacciatore',
      groups: 'gruppi',
      groups_list: 'Elenco dei gruppi',
      parent_attributes: 'Attributi principali',
      group_new: 'Nuovo gruppo',
      group_edit: 'Modifica gruppo',
      history: 'Cronologia degli accessi',
      history_list: 'Cronologia degli accessi',
      history_view: "Cronologia di accesso dell'utente",
      prices: 'Pricat',
      prices_list: 'elenco',
      price_new: 'nuovo Pricat',
      price: 'Modifica Pricat',
      price_categories: 'Listino prezzi',
      price_categories_list: 'elenco',
      price_categories_new: 'Nuovi listini prezzi',
      price_category: 'Listino prezzi',
      inactive_users: 'Rilascia nuove registrazioni',
      inactive_users_list: 'elenco',
      customer_numbers_to_approve: 'Nuove immatricolazioni senza numero',
      complaints: 'Modulo di reclamo',
      complaints_list: 'elenco',
      complaints_view: 'Rimostranza',
      orders_new: 'Nuovi ordini',
      points_list: 'Elenco punti',
      kickback_list: 'Commissione di contraccolpo',
      kickback_payout: 'Pagamento kickback',
      booster_preview: 'anteprima',
      frontend_menu: 'Menù frontend',
      frontend_menu_list: 'elenco',
      frontend_menu_new: 'Nuovo',
      'customer-groups': 'Gruppi clienti',
      'customer-groups-list': 'Elenco gruppi clienti',
      'customer-groups-new': 'Nuovo gruppo clienti',
      mediapages: 'Pacchetti multimediali',
      mediapages_list: 'elenco',
      media_page_new: 'Nuovo',
      mediapage: 'Modificare',
      uberall_request: 'Ovunque',
      history_hour: 'Tempi di registrazione',
      wholesaler_management: 'Gestione grossisti',
      mediapages_file_list: 'elenco dei file',
      vouchers: 'Vouchers',
      vouchers_list: 'List',
      vouchers_new: 'New',
      brochure_prices_list: 'Liste',
      brochure_file_list: 'Liste',
      brochure_prices: 'Broschüren & Preislisten',
      brochure_prices_new: 'Neu',
      main_boxes: 'Teaser Boxes',
      main_boxes_list: 'List',
      main_box: 'Edit',
      main_boxes_new: 'New',
      'hello-customer-survey': 'Sondaggio clienti Hello',
      apps_list: 'Elenco app',
      app_new: 'Nuovo',
      app: 'Modifica',
      about: 'Pagina Chi siamo',
      about_list: 'Elenco',
      about_new: 'Nuovo',
      about_edit: 'Modifica',
      contact_service: 'Servizio contatti',
      contact_service_list: 'Elenco',
      contact_service_new: 'Nuovo',
      contact_service_edit: 'Modifica',
      contact_service_description_list: 'Elenco delle descrizioni del servizio clienti',
      contact_service_description_edit: 'Modifica descrizione del servizio clienti',
      contact_service_description_new: 'Nuova descrizione del servizio clienti',
      points_exporter_users_with_available_points: 'Utenti con punti disponibili',
      points_exporter_unlocked_points: 'Esportazione di utenti con punti sbloccati',
      points_exporter_date_label: 'Data',
      points_exporter_download_button: 'Scarica Excel'
    },
    orders: {
      view: 'Ordine',
      new: 'Nuovo ordine',
      list: 'Ordini',
      edit: 'Modifica il tuo ordine',
      number: "Numero d'ordine",
      date: "Data dell'ordine",
      state: "lo stato dell'ordine",
      labels: {
        company: 'Azienda',
        name: 'Nome',
        street: 'Via',
        postalCodeCity: 'CAP / Città',
        userPhone: 'Telefono utente',
        userEmail: 'Email utente',
        orderPhone: "Telefono dell'ordine"
      },
      status: {
        created: 'Creato',
        confirm_order: "confermare l'ordine",
        ready_for_shipment: 'Pronto a spedire',
        rejected: 'Respinto',
        processed: 'Elaborato',
        shipped: 'Inviato',
        returned: 'Restituito',
        finished: 'Pronto',
        deleted: 'Cancellato'
      },
      cartQuantityIncreased: 'La quantità del prodotto nel carrello è stata aumentata.',
      cartQuantityDecreased: 'La quantità del prodotto nel carrello è stata diminuita.',
      confirmIncreaseItem: "Vuoi davvero aumentare la quantità di questo prodotto nell'ordine?",
      confirmDecreaseItem: "Vuoi davvero ridurre la quantità di questo prodotto nell'ordine?",
      confirmDeleteItem: "Vuoi davvero rimuovere questo prodotto dall'ordine?",
      deletedInfo: 'Questo ordine è stato cancellato il {date}',
      activityLogs: 'Cronologia delle modifiche',
      quantityChanged: 'Quantità: {from} → {to}',
      itemRemoved: 'Non consegnabile / rimosso'
    },
    salespromotions: {
      view: 'Promozione delle vendite',
      list: 'Promozioni di vendita',
      premium: 'GUIDA IL NOSTRO MEGLIO',
      guarantee: 'PROTEZIONE DEI PNEUMATICI',
      bonusCampaign: 'COLPI DI PNEUMATICI',
      advantage: 'PROMOZIONE VANTAGGIOSA'
    },
    countries: {
      ad: 'Andorra',
      ae: 'Emirati Arabi Uniti',
      af: 'Afghanistan',
      ag: 'Antigua e Barbuda',
      ai: 'Anguilla',
      al: 'Albania',
      am: 'Armenia',
      ao: 'Angola',
      aq: 'Antartide',
      ar: 'Argentina',
      as: 'Samoa americane',
      at: 'Austria',
      au: 'Australia',
      aw: 'Aruba',
      ax: 'Isole Åland',
      az: 'Azerbaigian',
      ba: 'Bosnia ed Erzegovina',
      bb: 'Barbados',
      bd: 'Bangladesh',
      be: 'Belgio',
      bf: 'Burkina Faso',
      bg: 'Bulgaria',
      bh: 'Bahrein',
      bi: 'Burundi',
      bj: 'Benin',
      bl: 'Saint-Barthélemy',
      bm: 'Bermuda',
      bn: 'Brunei',
      bo: 'Bolivia',
      bq: 'Caraibi olandesi',
      br: 'Brasile',
      bs: 'Bahamas',
      bt: 'Bhutan',
      bv: 'Isola Bouvet',
      bw: 'Botswana',
      by: 'Bielorussia',
      bz: 'Belize',
      ca: 'Canada',
      cc: 'Isole Cocos (Keeling)',
      cd: 'Congo - Kinshasa',
      cf: 'Repubblica Centrafricana',
      cg: 'Congo-Brazzaville',
      ch: 'Svizzera',
      ci: 'Costa d’Avorio',
      ck: 'Isole Cook',
      cl: 'Cile',
      cm: 'Camerun',
      cn: 'Cina',
      co: 'Colombia',
      cr: 'Costa Rica',
      cu: 'Cuba',
      cv: 'Capo Verde',
      cw: 'Curaçao',
      cx: 'Isola Christmas',
      cy: 'Cipro',
      cz: 'Cechia',
      de: 'Germania',
      dj: 'Gibuti',
      dk: 'Danimarca',
      dm: 'Dominica',
      do: 'Repubblica Dominicana',
      dz: 'Algeria',
      ec: 'Ecuador',
      ee: 'Estonia',
      eg: 'Egitto',
      eh: 'Sahara occidentale',
      er: 'Eritrea',
      es: 'Spagna',
      et: 'Etiopia',
      fi: 'Finlandia',
      fj: 'Figi',
      fk: 'Isole Falkland',
      fm: 'Micronesia',
      fo: 'Isole Fær Øer',
      fr: 'Francia',
      ga: 'Gabon',
      gb: 'Regno Unito',
      gd: 'Grenada',
      ge: 'Georgia',
      gf: 'Guyana Francese',
      gg: 'Guernsey',
      gh: 'Ghana',
      gi: 'Gibilterra',
      gl: 'Groenlandia',
      gm: 'Gambia',
      gn: 'Guinea',
      gp: 'Guadalupa',
      gq: 'Guinea Equatoriale',
      gr: 'Grecia',
      gs: 'Georgia del Sud e Sandwich Australi',
      gt: 'Guatemala',
      gu: 'Guam',
      gw: 'Guinea-Bissau',
      gy: 'Guyana',
      hk: 'RAS di Hong Kong',
      hm: 'Isole Heard e McDonald',
      hn: 'Honduras',
      hr: 'Croazia',
      ht: 'Haiti',
      hu: 'Ungheria',
      id: 'Indonesia',
      ie: 'Irlanda',
      il: 'Israele',
      im: 'Isola di Man',
      in: 'India',
      io: 'Territorio britannico dell’Oceano Indiano',
      iq: 'Iraq',
      ir: 'Iran',
      is: 'Islanda',
      it: 'Italia',
      je: 'Jersey',
      jm: 'Giamaica',
      jo: 'Giordania',
      jp: 'Giappone',
      ke: 'Kenya',
      kg: 'Kirghizistan',
      kh: 'Cambogia',
      ki: 'Kiribati',
      km: 'Comore',
      kn: 'Saint Kitts e Nevis',
      kp: 'Corea del Nord',
      kr: 'Corea del Sud',
      kw: 'Kuwait',
      ky: 'Isole Cayman',
      kz: 'Kazakistan',
      la: 'Laos',
      lb: 'Libano',
      lc: 'Saint Lucia',
      li: 'Liechtenstein',
      lk: 'Sri Lanka',
      lr: 'Liberia',
      ls: 'Lesotho',
      lt: 'Lituania',
      lu: 'Lussemburgo',
      lv: 'Lettonia',
      ly: 'Libia',
      ma: 'Marocco',
      mc: 'Monaco',
      md: 'Moldavia',
      me: 'Montenegro',
      mf: 'Saint Martin',
      mg: 'Madagascar',
      mh: 'Isole Marshall',
      mk: 'Macedonia del Nord',
      ml: 'Mali',
      mm: 'Myanmar (Birmania)',
      mn: 'Mongolia',
      mo: 'RAS di Macao',
      mp: 'Isole Marianne settentrionali',
      mq: 'Martinica',
      mr: 'Mauritania',
      ms: 'Montserrat',
      mt: 'Malta',
      mu: 'Mauritius',
      mv: 'Maldive',
      mw: 'Malawi',
      mx: 'Messico',
      my: 'Malaysia',
      mz: 'Mozambico',
      na: 'Namibia',
      nc: 'Nuova Caledonia',
      ne: 'Niger',
      nf: 'Isola Norfolk',
      ng: 'Nigeria',
      ni: 'Nicaragua',
      nl: 'Paesi Bassi',
      no: 'Norvegia',
      np: 'Nepal',
      nr: 'Nauru',
      nu: 'Niue',
      nz: 'Nuova Zelanda',
      om: 'Oman',
      pa: 'Panama',
      pe: 'Perù',
      pf: 'Polinesia francese',
      pg: 'Papua Nuova Guinea',
      ph: 'Filippine',
      pk: 'Pakistan',
      pl: 'Polonia',
      pm: 'Saint-Pierre e Miquelon',
      pn: 'Isole Pitcairn',
      pr: 'Portorico',
      ps: 'Territori palestinesi',
      pt: 'Portogallo',
      pw: 'Palau',
      py: 'Paraguay',
      qa: 'Qatar',
      re: 'Riunione',
      ro: 'Romania',
      rs: 'Serbia',
      ru: 'Russia',
      rw: 'Ruanda',
      sa: 'Arabia Saudita',
      sb: 'Isole Salomone',
      sc: 'Seychelles',
      sd: 'Sudan',
      se: 'Svezia',
      sg: 'Singapore',
      sh: 'Sant’Elena',
      si: 'Slovenia',
      sj: 'Svalbard e Jan Mayen',
      sk: 'Slovacchia',
      sl: 'Sierra Leone',
      sm: 'San Marino',
      sn: 'Senegal',
      so: 'Somalia',
      sr: 'Suriname',
      ss: 'Sud Sudan',
      st: 'São Tomé e Príncipe',
      sv: 'El Salvador',
      sx: 'Sint Maarten',
      sy: 'Siria',
      sz: 'eSwatini',
      tc: 'Isole Turks e Caicos',
      td: 'Ciad',
      tf: 'Terre australi francesi',
      tg: 'Togo',
      th: 'Thailandia',
      tj: 'Tagikistan',
      tk: 'Tokelau',
      tl: 'Timor Est',
      tm: 'Turkmenistan',
      tn: 'Tunisia',
      to: 'Tonga',
      tr: 'Turchia',
      tt: 'Trinidad e Tobago',
      tv: 'Tuvalu',
      tw: 'Taiwan',
      tz: 'Tanzania',
      ua: 'Ucraina',
      ug: 'Uganda',
      uk: 'Regno Unito',
      um: 'Isole Minori Esterne degli Stati Uniti',
      us: 'Stati Uniti',
      uy: 'Uruguay',
      uz: 'Uzbekistan',
      va: 'Città del Vaticano',
      vc: 'Saint Vincent e Grenadine',
      ve: 'Venezuela',
      vg: 'Isole Vergini Britanniche',
      vi: 'Isole Vergini Americane',
      vn: 'Vietnam',
      vu: 'Vanuatu',
      wf: 'Wallis e Futuna',
      ws: 'Samoa',
      xk: 'Kosovo',
      ye: 'Yemen',
      yt: 'Mayotte',
      za: 'Sudafrica',
      zm: 'Zambia',
      zw: 'Zimbabwe'
    },
    messages: {
      list: 'Notizia',
      new: 'Nuovo messaggio',
      edit: 'modificare il messaggio',
      title: 'titolo',
      content: 'Contenuti',
      empty: 'Nessuna novità',
      direct: 'Messaggio diretto',
      toDealers: 'Ai rivenditori',
      sendEmail: 'Invia una email',
      selectWholesalers: 'Seleziona grossista',
      directWholesaler: 'dal grossista al rivenditore',
      selectGroups: 'Seleziona gruppi',
      directGroup: 'Ai gruppi di rivenditori',
      toGroups: 'Ai gruppi',
      saveAndSend: 'Salva e invia',
      users: 'Seleziona utente (min. 3 caratteri)',
      sent: 'Pubblicato',
      externalTrainingPoints: 'Punti di supporto per formazione/investimenti esterni',
      externalTrainingBank: 'Titolari di conti di supporto per formazione/investimenti esterni',
      externalTrainingIBAN: 'Formazione esterna/supporto agli investimenti IBAN',
      onlineTrainingTitle: 'Formazione online - Titolo',
      onlineTrainingPoints: 'Formazione online - punti',
      hunterTitle: 'Cacciatore - titolo',
      hunterPoints: 'Cacciatore - punti',
      hunterPrice: 'Cacciatore - prezzo',
      bTrainingTitle: 'Corsi di formazione Bridgestone - titolo',
      bTrainingPoints: 'Formazione BS - Punti',
      pointsProfileComplete: 'Punti: profilo completato',
      orderProducts: "Prodotti nell'ordine"
    },
    messages_alert: {
      title: 'Cancella il messaggio',
      desc: 'Sei sicuro di voler eliminare il messaggio?'
    },
    groups_alert: {
      title: 'Elimina gruppo',
      desc: 'Sei sicuro di voler eliminare il gruppo?'
    },
    vendors_alert: {
      title: 'Elimina produttore',
      desc: 'Vuoi davvero eliminare il produttore?'
    },
    suppliers_alert: {
      title: 'Elimina fornitore',
      desc: 'Vuoi davvero eliminare il fornitore?'
    },
    threads: {
      title: 'Per quanto riguarda',
      choose: 'Seleziona il messaggio',
      order: "Seleziona l'oggetto degli ordini",
      salespromotions: "Seleziona l'oggetto per la promozione delle vendite",
      externalTraining: 'Seleziona la materia per la formazione esterna',
      investment: 'Oggetto del sostegno agli investimenti',
      onlineTraining: 'Oggetto della formazione online',
      hunter: 'Oggetto per Hunter',
      bTraining: 'Oggetto per la formazione Bridgestone',
      profileComplete: 'Oggetto per il completamento del profilo',
      activeUser: 'Messaggio utente attivo'
    },
    userGroup: {
      parentAttributeName: 'Attributo padre',
      name: 'Nome del gruppo',
      gka: 'GKA',
      isMain: 'È principale?',
      dealersGroupTab: 'Gruppo rivenditori',
      dealersTab: 'Rivenditori',
      searchDealers: 'Cerca rivenditori'
    },
    customerGroup: {
      name: 'Nome del gruppo clienti'
    },
    role: 'ruolo',
    user: 'utente',
    vat: 'codice fiscale',
    categories: 'Categorie',
    count_users: 'numero di utenti',
    product: 'Prodotto',
    count_perms: 'Numero di diritti',
    count_products: 'Numero di prodotti',
    count_files: 'Numero di file',
    count_options: 'Numero di opzioni',
    attribute_new: 'Nuovo attributo',
    category_new: 'Nuova categoria',
    category_title: 'Titolo della categoria',
    category_desc: 'Descrizione della categoria',
    category_image: 'Immagine di categoria',
    category_link: 'Collegamento di categoria',
    category_alert: {
      title: 'Elimina categoria',
      desc: 'Sei sicuro di voler eliminare la categoria?'
    },
    text_page_alert: {
      title: 'Elimina pagina di testo',
      desc: 'Sei sicuro di voler eliminare la pagina di testo?'
    },
    news_feed_alert: {
      title: 'Elimina news feed',
      desc: 'Vuoi davvero eliminare il news feed "{title}"?'
    },
    newsFeedList: {
      perPage: 'Elementi per pagina',
      loading: 'Caricamento news feed…',
      paginationSummary: '{from}–{to} di {total} (pagina {page} / {lastPage})',
      moveUp: 'Sposta su',
      moveDown: 'Sposta giù'
    },
    ipcList: {
      title: 'Elenco IPC',
      perPage: 'Righe per pagina',
      clearFilters: 'Cancella filtri',
      loading: 'Caricamento IPC…',
      accessDenied: 'Non hai il permesso di visualizzare l’elenco IPC.',
      paginationSummary: '{from}–{to} di {total}',
      columns: {
        material: 'Materiale / IPC',
        detailed_brand: 'Marca dettagliata',
        tyre_size_designation: 'Misura pneumatico',
        new_budget_category: 'Categoria budget',
        service_description: 'Descrizione servizio',
        rim: 'Cerchio',
        marketing_product_brand: 'Marca marketing',
        marketing_product_name: 'Nome prodotto marketing'
      }
    },
    slider_alert: {
      title: 'Elimina slider',
      desc: 'Vuoi davvero eliminare lo slider "{title}"?'
    },
    question_alert: {
      title: 'Delete Question',
      desc: 'Do you really want to delete the question?'
    },
    certificate_alert: {
      title: 'Delete Certificate Text',
      desc: 'Do you really want to delete the certificate text?'
    },
    product_alert: {
      title: 'Elimina prodotto',
      desc: 'Sei sicuro di voler eliminare il prodotto?'
    },
    cancel: 'Annulla',
    confirm: 'Confermare',
    options_new: 'Nuova opzione',
    subcategory: 'Sottocategoria',
    uploadText: "per caricare un'immagin",
    startImport: "Avvia l'importazione",
    importStarted: "L'importazione è iniziata",
    connection: 'Connessione',
    variants: 'varianti',
    add_variant: 'Aggiungi variante',
    vendor_new: 'Nuovo produttore',
    training_edit: 'Modifica formazione',
    vendors: 'Produttore',
    supplier_new: 'Nuovo fornitore',
    suppliers: 'fornitori',
    training: 'formazione',
    commands: {
      ipc: 'Importatore IPC',
      users: 'Importa utenti'
    },
    userImport: {
      label: 'Solo tipo XLSX'
    },
    questions: 'Domande',
    correctAnswer: 'Risposta correttat',
    validation: {
      required: 'Il campo è obbligatiorio'
    },
    edit_question: 'Modifica domande',
    edit_btraining_Detail: 'Modifica i dettagli della formazione Bridgestone',
    video_url: 'URL del video',
    save_new_question: 'Salva nuova domanda',
    reward: 'Illustrazione del premio - non necessaria',
    poster: 'Immagine del manifesto',
    sliderImageValidation: "L'immagine deve essere 1600x1040 px o 2x/3x/4x di questa dimensione.",
    mainBoxImageValidation: "L'immagine deve essere 368x150 px o 2x/3x/4x di questa dimensione.",
    imageDimensions: 'Dimensioni immagine',
    season: 'stagione',
    answers: 'Risposta',
    training_details: 'Dettagli della formazione',
    extras: 'Ulteriori informazioni',
    duration: 'Periodo di tempo',
    price: 'Prezzo',
    min_participant: 'Numero minimo di partecipanti',
    max_participant: 'Numero massimo di partecipanti',
    choose_trainingType: 'Seleziona il tipo di allenamento',
    update: 'Aggiornare',
    cost_type: 'Tipo di costo',
    save_detail: 'Salva i dettagli',
    slider_new: 'Nuovo cursore principale del teaser',
    sliders: 'Cursore principale del teaser',
    groups: 'gruppi',
    slider: 'Modifica il dispositivo di scorrimento del teaser principale',
    choose_showHideText: 'Mostra/nascondi testo',
    text_page_new: 'Nuova pagina di testo',
    text_pages: 'Pagine di testo',
    text_page: 'Pagina di testo',
    featured: {
      title: 'Prodotti teaser',
      bestseller: 'Il più venduto',
      seasonal: 'di stagione',
      affordable: 'Quasi lì',
      autoBestsellers: 'Mostra i bestseller calcolati automaticamente',
      affordableOffsetLabel: 'Massima compensazione del prezzo',
      affordableLimitLabel: 'Mostra limite prodotto'
    },
    seasons: {
      all: 'Tutte le stagioni',
      summer: 'Estate',
      winter: 'inverno',
      general: 'Generalmente'
    },
    addAddress: 'Aggiungi indirizzo',
    administration: 'Amministrazione',
    password: "parola d'ordine",
    forcedPasswordChange: {
      title: 'Cambia la tua password',
      description: "La password temporanea deve essere cambiata prima di accedere all'applicazione.",
      enterNewPassword: 'Inserisci la nuova password',
      repeatNewPassword: 'Ripeti la nuova password',
      strengthLabel: 'Sicurezza password',
      submit: 'Cambia password e accedi',
      generatePassword: 'Genera password sicura',
      success: 'La password è stata cambiata con successo',
      loginAfterChangeFailed:
        "La password è stata cambiata, ma l'accesso automatico non è riuscito. Accedi con la nuova password.",
      sameAsTemporaryPassword: 'La nuova password non può essere uguale alla password temporanea.',
      validationError: 'Correggi i requisiti della password prima di continuare.',
      invalidToken: 'La sessione di cambio password è scaduta. Accedi di nuovo.',
      rules: {
        minLength: 'Almeno 12 caratteri',
        uppercase: 'Almeno una lettera maiuscola',
        lowercase: 'Almeno una lettera minuscola',
        digit: 'Almeno una cifra',
        special: 'Carattere speciale consigliato'
      }
    },
    toastMessages: {
      success: "L'operazione è stata completata con successo",
      error: 'Errore imprevisto, riprova più tardi',
      invalid: 'Valori non validi nel modulo',
      done: 'Completato!',
      requestProcessed: 'La richiesta è in fase di elaborazione. Un momento per favore...',
      noQuestions: 'La formazione deve contenere almeno 1 domanda',
      pointsAdded: 'Prenotazione effettuata',
      selectUser: "Seleziona un utente dall'elenco",
      selectOneField: 'Seleziona un campo',
      pointRemoveSoon: 'I punti verranno eliminati a breve',
      dataLoading: 'I dati sono in caricamento, attendi',
      shopStatsStartImportUser: 'Avvio importazione: Statistiche Shop - UTENTE',
      shopStatsPrepareMissingExportToken: 'Lo step Prepare non ha restituito export_token.',
      shopStatsPrepareInvalidNextChunk: 'Lo step Prepare ha restituito un next_chunk non valido.',
      shopStatsPrepareUnchangedChunkCursor: 'Lo step Prepare ha restituito chunk/cursor invariati.',
      shopStatsPrepareMaxIterations: 'Lo step Prepare ha superato il numero massimo di iterazioni.',
      shopStatsConvertInvalidNextSubstep: 'Lo step Convert ha restituito un next_substep non valido.',
      shopStatsConvertMaxIterations: 'Lo step Convert ha superato il numero massimo di iterazioni.',
      shopStatsExportInvalidDownloadUrl: 'Lo step Export non ha restituito un URL di download valido.',
      shopStatsDone: 'Fatto',
      shopStatsExportFailed: 'Esportazione fallita'
    },
    stats: {
      users_list: 'numero di utenti',
      external_trainings_request: 'Formazione esterna',
      product_trainings_request: 'Formazione in linea',
      bridgestone_courses_request: 'Allenamento Bridgestone',
      hunter_request: 'Cacciatore',
      investments_request: 'Sostegno agli investimenti',
      orders_list: 'Ordini',
      history_list: 'Cronologia degli accessi',
      salespromotions_list: 'Promozione delle vendite',
      inactive_users: 'Rilascia nuove registrazioni',
      complaints_list: 'Modulo di reclamo',
      points_list: 'Elenco punti',
      kickback_list: 'Commissione di contraccolpo',
      history_hour: 'Tempi di registrazione',
      tyre_list: 'Pneumatici'
    },
    product_trainings_request: 'Richieste di formazione online',
    bridgestone_courses_request: 'Richieste di formazione Bridgestone',
    attempt_number: 'Numero di prova',
    thirdPartyInvoice: 'Fattura di terzi',
    userInvoice: "Fattura dell'utente",
    bankAccountOwner: "titolare dell'account",
    open: 'Aprire',
    appLogo: "Logo dell'applicazione",
    appURL: "URL dell'applicazione",
    appURLSSOLogin: 'URL dopo login SSO',
    url: 'URL',
    url_text: "Testo dell'URL",
    choose_posterSide: 'Pagina immagine: ',
    left: 'Sinistra',
    right: 'Giusto',
    disclaimer: 'Disclaimer',
    supply: {
      history: 'Storia della fornitura',
      quantity: 'Folla'
    },
    copyAsMain: 'Copia come teaser principale',
    news_feed_slider_list: "L'elenco dei dispositivi di scorrimento del feed di notizie",
    usersPage: {
      boostersToApprove: "Booster per l'approvazione",
      lastLogin: 'Ultimo accesso',
      isPreonboarded: 'Pre-onboarding completato',
      isBl: 'Capo dipartimento',
      customerNumbers: 'Numero cliente',
      branches: 'rami',
      balance: 'saldo bancario',
      orders: 'Ordini',
      groups: 'gruppi',
      notes: 'Osservazioni',
      salesStaff: 'Vendite esterne',
      parentBranch: 'business principale',
      childBranch: 'ramo',
      addWholesaler: 'Aggiungi grossista',
      addBranch: 'Aggiungi ramo',
      tooltip: 'Per aggiungere una filiale è necessario salvare il numero cliente del negozio principale',
      tooltipRmCnLocal: 'Rimuovere il numero cliente locale',
      tooltipRmCnDB: 'Rimuovere il numero cliente per il database',
      statement: 'estratto conto',
      bank: {
        date: 'Data',
        supplySourceReason: 'Fonte/motivo',
        customerNumber: 'Kdnr.',
        article: 'Articolo',
        brand: 'marca',
        product: 'Prodotto',
        type: 'Tipo',
        dimension: 'Dimensione',
        inch: 'Dogana',
        season: 'stagione',
        amount: 'Folla',
        otherActions: 'Altra azione o causa',
        totalPoints: 'Punti totali',
        editPoint: 'Modifica punti',
        deleteManualPointConfirm: 'Sei sicuro di voler eliminare questa voce manuale di punti ({points} punti, {date})?',
        loadMore: 'Caricare altri 20 fatturati',
        showAll: 'Mostra tutto',
        seasons: {
          all: 'Tutte le stagioni',
          summer: 'Cicalino',
          winter: 'inverno',
          general: 'generale'
        }
      },
      advanced: 'Avanzate',
      deleteUser: "eliminare l'utente",
      deleteUserConfirm: "Sei sicuro di voler eliminare l'utente?",
      deleteUserSuccess: "L'utente è stato eliminato.",
      deleteUserNotFound: "L'utente non esiste o è già stato eliminato.",
      deleteUserDealerConflict:
        'Non è possibile eliminare il dealer perché ha numeri cliente attivi. Rimuovi prima i numeri cliente collegati.',
      deleteUserError: "Non è stato possibile eliminare l'utente. Riprova.",
      generateTemporaryPassword: 'Genera password temporanea',
      generateTemporaryPasswordConfirm:
        'Sei sicuro di voler reimpostare la password per {user}? La password attuale non funzionerà più.',
      temporaryPasswordGeneratedTitle: 'Password temporanea generata',
      temporaryPasswordOneTimeWarning:
        'Questa password viene mostrata solo una volta. Copiala prima di chiudere questa finestra.',
      copyPassword: 'Copia negli appunti',
      passwordCopied: 'Copiato',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password',
      generateTemporaryPasswordForbidden: 'Non hai il permesso di generare una password temporanea.',
      generateTemporaryPasswordNotFound: "L'utente non esiste.",
      passwordMismatch: 'Le password non corrispondono',
      deleteCustomerNumber: 'Elimina numero cliente',
      manageSalesStaff: 'Gestisci agenti commerciali',
      availableSalesStaff: 'Agenti commerciali disponibili',
      assignedSalesStaff: 'Agenti commerciali assegnati',
      salesStaffTransferHint:
        'Seleziona uno o più agenti commerciali a sinistra o a destra. Usa le frecce per collegarli o scollegarli da questo dealer.',
      transferSalesStaffRight: 'Collega agente commerciale selezionato',
      transferSalesStaffLeft: 'Scollega agente commerciale selezionato',
      salesStaffSearchNoResults: 'Nessun agente commerciale corrispondente trovato.',
      addSalesStaff: 'Aggiungi agente commerciale',
      selectSalesStaffToAdd: 'Seleziona un agente commerciale da aggiungere',
      noSalesStaffAssigned: 'Nessun agente commerciale assegnato.',
      noSalesStaffAvailable: 'Tutti gli agenti commerciali disponibili sono già assegnati.',
      addSalesStaffConfirm: 'Sei sicuro di voler aggiungere il commerciale {salesStaff} a questo dealer?',
      deleteSalesStaffConfirm: 'Sei sicuro di voler rimuovere il commerciale {salesStaff} da questo dealer?',
      deleteAddressConfirm: 'Sei sicuro di voler eliminare questo indirizzo?',
      milestones: {
        targetLabel: 'Obiettivo',
        yearLabel: 'Anno',
        new: 'Nuovo',
        empty: 'Nessun obiettivo per alcun anno. Creane uno nuovo.',
        editTitle: 'Modifica obiettivo',
        createTitle: 'Crea obiettivo',
        deleteConfirm: 'Sei sicuro di voler eliminare la milestone per l’obiettivo {target} e l’anno {year}?',
        targetRequiredInfo: "Il target è necessario per il corretto calcolo dei punti per l'anno selezionato."
      },
      milestonesTab: 'Milestone',
      campaignsTab: 'Campagne',
      dealerGroupsLabel: 'Gruppi rivenditori',
      preOnboardStatusLabel: 'Stato pre-onboard',
      extraEmailsTab: 'Email extra',
      customerGroupsLabel: 'Gruppi clienti',
      customerGroupsNone: 'Nessuno',
      showDealersList: 'Mostra elenco rivenditori',
      staffDealersList: 'Elenco dei tuoi rivenditori',
      syncSelectedDealers: 'Sincronizza i rivenditori selezionati',
      connectAllDealersFromBs: 'Collega tutti i rivenditori da BS+',
      connectAllDealersConfirmTitle: 'Collega tutti i rivenditori',
      connectAllDealersConfirmDescription: 'Sei sicuro di voler collegare tutti i rivenditori a questo utente staff?',
      disconnectAllDealersConfirmTitle: 'Scollega tutti i rivenditori',
      disconnectAllDealersConfirmDescription: 'Sei sicuro di voler scollegare tutti i rivenditori da questo utente staff?',
      transferDealersToAnotherBsStaff: 'Trasferisci i rivenditori a un altro membro staff BS',
      showingCount: 'Visualizzati {visible} / {total}',
      groupDealersSelectedCount: '{selected} selezionati',
      groupDealersUnselectedCount: '{unselected} non selezionati',
      showGroupOnly: 'Mostra solo',
      clearGroupFilter: 'Mostra tutti i gruppi',
      noDealersInSelectedGroups: 'Nessun rivenditore nei gruppi selezionati',
      downloadConnectedDealers: 'Scarica rivenditori collegati',
      showGroupFilters: 'Mostra filtri gruppo',
      hideGroupFilters: 'Nascondi filtri gruppo',
      staffDealersToolbarSync: 'Sincronizzazione',
      staffDealersToolbarBulk: 'Azioni di massa',
      staffDealersToolbarExport: 'Export',
      importDealersByEmail: 'Importa rivenditori da Excel',
      importDealersByEmailTitle: 'Importa rivenditori tramite e-mail',
      importDealersByEmailInfo: 'Carica un file Excel (.xlsx, .xls) con indirizzi e-mail solo nella colonna A.',
      importDealersByEmailHeaderInfo: 'La prima riga può contenere l\'intestazione "email".',
      importDealersByEmailEmptySheet: 'Il file Excel non contiene dati.',
      importDealersByEmailEmptyColumn: 'La colonna A non contiene indirizzi e-mail.',
      importDealersByEmailMultipleColumns: 'Il file deve contenere una sola colonna con indirizzi e-mail.',
      importDealersByEmailReadError: 'Impossibile leggere il file Excel.',
      importDealersByEmailValidating: 'Validazione del file...',
      importDealersByEmailSummaryTitle: 'Riepilogo importazione',
      importDealersByEmailAlreadyConnected: 'Già collegati',
      importDealersByEmailNewConnections: 'Nuovi collegamenti',
      importDealersByEmailNotFound: 'Non trovati in BS+',
      importDealersByEmailInvalidEmails: 'Formato e-mail non valido',
      importDealersByEmailDuplicates: 'E-mail duplicate nel file',
      importDealersByEmailSyncButton: 'Collega e sincronizza',
      importDealersByEmailNoNewConnections: 'Tutte le e-mail del file sono già collegate.',
      importDealersByEmailShowingCount: 'Visualizzati {shown} di {total}',
      notesHelpText: 'Deve essere lungo 8-20 parole.',
      indirectAccessAlert: 'Questo utente ha accesso limitato a causa del percorso di tipo cliente INDIRECT.',
      parentAttributesNotEnabled:
        'Non è possibile salvare gli attributi parent per questo mercato. Chiedi a un super admin di abilitare questa funzione.',
      termsConfirmed: 'Termini e condizioni confermati',
      privacyConfirmed: 'Informativa sulla privacy confermata',
      approvedByBs: 'Approvato da BS+',
      extraDocsConfirmed: 'Documenti extra per cliente indiretto confermati',
      restrictedAccess: 'Accesso limitato',
      revokeApproval: 'Revoca approvazione',
      approve: 'Approva',
      allowPointsCalculationConfirm:
        'Do you want to activate/deactivate points calculation for customer number {customerNumber} ({wholesaler})?',
      calculateOneCustomerNumberTitle: 'Calculate points for customer number',
      calculateOneCustomerNumberQuestion: 'Would you like to calculate data for customer number {customerNumber}?',
      calculateOneCustomerNumberWholesaler: 'Wholesaler: {wholesaler}',
      calculateOneCustomerNumberYearLabel: 'Year',
      activateCustomerNumberConfirm: 'Are you sure you want to activate customer number {customerNumber} ({wholesaler})?',
      deactivateCustomerNumberConfirm: 'Are you sure you want to deactivate customer number {customerNumber} ({wholesaler})?',
      saveCustomerNumberConfirm: 'Sei sicuro di voler salvare o aggiornare il numero cliente {customerNumber} ({wholesaler})?',
      selectRole: 'Seleziona ruolo',
      selectClientType: 'Seleziona tipo di cliente',
      selectWholesaler: 'Seleziona grossista',
      pointsSummary: {
        year: 'Anno',
        actions: 'Azioni',
        revert: 'Annulla scadenza',
        recalculate: 'Ricalcola scadenza',
        currentPoints: 'Saldo punti',
        pointsFromCurrentYear: 'Punti dell’anno corrente ({year})',
        atRiskLabel: 'Punti da spendere entro il 31.03.{year}',
        loadError: 'Impossibile caricare il riepilogo punti.',
        invalidYear: "L'anno deve essere un numero intero tra 2000 e 3000.",
        recalculateConfirm: "Questa azione rimuoverà la vecchia scadenza e la ricalcolerà per l'anno {year}. Continuare?",
        revertSuccess: 'Voci rimosse: {count}',
        revertConfirm: "Questa azione rimuoverà le voci di scadenza per l'anno {year}. Continuare?",
        recalculateSuccess: 'Ricalcolato. Punti scaduti: {points}',
        recalculateNoop: 'Nessun punto da far scadere per questo anno.'
      }
    },
    recoverUser: 'Riporta indietro gli utenti',
    pieces_per_set: 'Unità di imballaggio',
    new: 'Nuovo',
    all: 'Tutto',
    showAddress: 'Mostra indirizzo',
    showGroup: 'Mostra GKA e Bl-Alt',
    showPoints: 'Visualizza i punteggi',
    showKickbacks: 'Mostra la commissione di tangente',
    external_sales: 'Vendite esterne',
    login_from: 'Ultimo accesso (da)',
    login_to: 'Ultimo accesso (fino al)',
    searchUserDownload: {
      title: 'Scarica dati di ricerca',
      description: 'Scegli il formato del file per l’export.',
      formatCsv: 'CSV (.csv)'
    },
    check: 'Controllo',
    reject: 'Rifiutare',
    reason: 'Motivo',
    active_by: 'Attivato da',
    sharePassword: 'Condividi questa password con il nuovo amministratore',
    activeBtn: 'Attivare ora',
    newUserVerify: 'Verifica della nuova iscrizione',
    complaintForm: {
      sections: {
        general: {
          title: 'generalmente',
          ordinance: 'Il concetto di ordine del rivenditore',
          generalEmail: 'Il tuo indirizzo di posta elettronica',
          country: 'Paese',
          pickupLocation: 'Posto di raccolta'
        },
        regulator: {
          title: 'indirizzo gommista - regolatore'
        },
        vehicleDetails: {
          title: 'Informazioni sul veicolo',
          vehicleManufacturer: 'Produttore di veicoli',
          vehicleModelType: "Modello del veicolo e designazione del tipo secondo l'omologazione",
          firstRegistration: 'Registrazione iniziale',
          enginePower: 'Potenza motore (KW es. 150)',
          originalEquipment: 'Equipaggiamento originale',
          tireMilageHours: 'Chilometraggio pneumatici (km) / ore di funzionamento',
          milageOrHours: 'Km o ore (es. 2000)'
        },
        tyre: {
          tireSizeExample: 'Misura pneumatici (es. 215/60/16)',
          speedLoadIndex: 'Indice di velocità/carico',
          profileDesignation: 'Denominazione del profilo incl. specifica',
          dot: 'PUNTO',
          truckSerialNo: 'Numero di serie. (solo per pneumatici camion)',
          complaintReason: 'Motivo del reclamo',
          isTyreReplaced: 'I pneumatici sono già stati sostituiti?',
          ifYesTyre: 'Se sì, marca degli pneumatici sostitutivi',
          clerkName: "Nome dell'impiegato",
          complaintReasonText: 'Testo del motivo del reclamo'
        }
      }
    },
    yesText: 'si',
    noText: 'no',
    tyre: 'Pneumatici',
    maintenance_mode_title: 'Modalità manutenzione',
    maintenance_mode_description:
      'Sei sicuro di voler continuare? Quando è attiva, il sito sarà temporaneamente non disponibile per gli utenti.',
    maintenance_mode_disable_title: 'Disattiva modalità manutenzione',
    maintenance_mode_disable_description: 'Sei sicuro di voler continuare? Il sito tornerà disponibile per gli utenti.',
    buttons: {
      close: 'Vicino',
      send: 'Invia',
      validateFile: 'Convalida file',
      back: 'Indietro',
      placeOrder: 'Ordine vincolante',
      download: 'Scaricamento',
      downloadData: 'Scarica dati',
      downloadSearchResults: 'Scarica dati di ricerca',
      openDownloadModal: 'Mostra finestra di download dati',
      loading: 'Caricamento',
      approve: 'Permettere',
      deleteOrder: 'Elimina ordine',
      archive: 'Archivio',
      acceptAll: 'Accettare tutti',
      advanceSearch: 'Ricerca Avanzata',
      addMenu: 'Aggiungi menù',
      setMaintenance: 'Imposta la manutenzione',
      hideMaintenance: 'Nascondi manutenzione',
      deactivate: 'Disattivare',
      importSelected: 'Importa selezionato',
      startOver: 'Ricomincia',
      loadMore: 'Carica altro',
      loadAll: 'Carica tutto',
      clearFilters: 'Filter zurücksetzen',
      toSearch: 'Search',
      delete: 'Delete',
      allowAccessToUsers: "Permetti l'accesso a un gruppo di utenti"
    },
    others: 'Altro',
    archive_training_title: 'Archivia formazione',
    archive_training: 'Sei sicuro di voler archiviare questa formazione?',
    delete_menu: 'Vuoi eliminare la voce di menu?',
    no_entries: 'Nessuna voce',
    external_url: 'URL esterno',
    incomplete_address: "L'indirizzo è incompleto. si prega di controllare",
    request_from: 'richiesta da',
    let_see_points: "Consenti all'utente di vedere i punti di marketing",
    let_see_kickback: "Consenti all'utente di vedere la commissione di tangente",
    major: 'Grep',
    media_category: 'Categoria “Media”',
    dragHere: 'Rilascia i file qui...',
    dragDropSelectFiles: 'Trascina qui i file oppure fai clic per selezionarli',
    publicFileUploadWarning:
      "I file caricati saranno accessibili pubblicamente. Se dati pubblici o sensibili vengono condivisi per errore, l'utente potrebbe avere seri problemi. Il caricamento avviene sotto la propria responsabilita.",
    uploadingFiles: 'Caricamento dei file',
    uploadingCurrentFile: 'File corrente',
    allCategories: 'Tutte le categorie',
    addEmbbeded: 'Aggiungi codice incorporato',
    canReceivePoints: 'Può ottenere punti',
    canUsePoints: 'Può usare i punti',
    wholesaler_management: {
      modal: {
        description: 'Quali dati può vedere il grossista nei dettagli del rivenditore?'
      }
    },
    personalData: 'Dati personali',
    operatingData: 'Dati operativi',
    orderDelivery: 'indirizzo di consegna',
    diffDeliveryAddres: 'aggiungi un indirizzo di consegna',
    current_tyres_amount: 'Importo del pneumatico',
    current_points: 'Punto',
    current_kickbacks: 'Kick-back',
    change_role_info:
      "La modifica di un ruolo nel sistema <b>Bridgestone PLUS-System</b> elimina le connessioni associate a un determinato ruolo, ad es. punti, numeri cliente, connessioni tra un processore Bridgestone e un rivenditore, ordini, ecc. vengono eliminati. Sei sicuro di voler apportare questa modifica perché non c'è modo di tornare indietro?",
    firstRegistration: 'Prima registrazione',
    mediaCategories: {
      products: 'Produkte',
      brand_and_solutions: 'Marke & Lösungen',
      season_and_promotions: 'Saison & Aktionen',
      format: 'Format',
      cars_and_vans: 'Pkw & Transporter',
      truck_and_buses: 'Lkw & Bus',
      motorcycle: 'Motorrad',
      agriculture: 'Landwirtschaft',
      construction_machinery: 'Baumaschinen',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      summer: 'Sommer',
      winter: 'Winter',
      all_season: 'All Season',
      promotions: 'Promotions',
      video_in_store: 'Video (Instore)',
      video_online: 'Video (Online)',
      banner_website: 'Banner (Webseite)',
      banner_social_media: 'Banner (Social Media)',
      logos: 'Logos',
      b_drive: 'B-drive',
      media_library: 'Media library',
      media_packages: 'Media packages',
      material: 'Materiali',
      price_list: 'Listino prezzi',
      brochures: 'Brochure',
      price: 'Prezzo'
    },
    fileType: {
      label: 'File type',
      video: 'Video',
      image: 'Image',
      embeded: 'Embeded',
      pdf: 'PDF'
    },
    deleteMediaModal: {
      title: 'Delete media collection',
      description: "Do you confirm delete file's collection? It will delete all connect files.",
      filesLabel: 'File che verranno eliminati',
      noFiles: 'Nessun file in questa raccolta'
    },
    deleteMediaFileModal: {
      title: 'Delete file from collection',
      description: 'Do you want to you delete file from this collection?'
    },
    deleteBrochureFileModal: {
      title: 'Elimina file dalla raccolta',
      description: 'Vuoi eliminare il file "{fileName}" da questa raccolta?',
      fileNameFallback: 'File sconosciuto'
    },
    deleteBrochureModal: {
      title: 'Elimina brochure',
      description: 'Sei sicuro di voler eliminare la brochure "{name}"?',
      nameFallback: 'Brochure sconosciuta',
      filesLabel: 'File che verranno eliminati',
      noFiles: 'Nessun file in questa brochure'
    },
    languages: {
      aa: 'afar',
      ab: 'abcaso',
      ae: 'avestan',
      af: 'afrikaans',
      ak: 'akan',
      am: 'amarico',
      an: 'aragonese',
      ar: 'arabo',
      as: 'assamese',
      av: 'avaro',
      ay: 'aymara',
      az: 'azerbaigiano',
      ba: 'baschiro',
      be: 'bielorusso',
      bg: 'bulgaro',
      bh: 'bhojpuri',
      bi: 'bislama',
      bm: 'bambara',
      bn: 'bengalese',
      bo: 'tibetano',
      br: 'bretone',
      bs: 'bosniaco',
      ca: 'catalano',
      ce: 'ceceno',
      ch: 'chamorro',
      co: 'corso',
      cr: 'cree',
      cs: 'ceco',
      cu: 'slavo ecclesiastico',
      cv: 'ciuvascio',
      cy: 'gallese',
      da: 'danese',
      de: 'tedesco',
      dv: 'divehi',
      dz: 'dzongkha',
      ee: 'ewe',
      el: 'greco',
      en: 'inglese',
      eo: 'esperanto',
      es: 'spagnolo',
      et: 'estone',
      eu: 'basco',
      fa: 'persiano',
      ff: 'fulah',
      fi: 'finlandese',
      fj: 'figiano',
      fo: 'faroese',
      fr: 'francese',
      fy: 'frisone occidentale',
      ga: 'irlandese',
      gd: 'gaelico scozzese',
      gl: 'galiziano',
      gn: 'guaraní',
      gu: 'gujarati',
      gv: 'mannese',
      ha: 'hausa',
      he: 'ebraico',
      hi: 'hindi',
      ho: 'hiri motu',
      hr: 'croato',
      ht: 'creolo haitiano',
      hu: 'ungherese',
      hy: 'armeno',
      hz: 'herero',
      ia: 'interlingua',
      id: 'indonesiano',
      ie: 'interlingue',
      ig: 'igbo',
      ii: 'sichuan yi',
      ik: 'inupiak',
      io: 'ido',
      is: 'islandese',
      it: 'italiano',
      iu: 'inuktitut',
      ja: 'giapponese',
      jv: 'giavanese',
      ka: 'georgiano',
      kg: 'kongo',
      ki: 'kikuyu',
      kj: 'kuanyama',
      kk: 'kazako',
      kl: 'groenlandese',
      km: 'khmer',
      kn: 'kannada',
      ko: 'coreano',
      kr: 'kanuri',
      ks: 'kashmiri',
      ku: 'curdo',
      kv: 'komi',
      kw: 'cornico',
      ky: 'kirghiso',
      la: 'latino',
      lb: 'lussemburghese',
      lg: 'ganda',
      li: 'limburghese',
      ln: 'lingala',
      lo: 'lao',
      lt: 'lituano',
      lu: 'luba-katanga',
      lv: 'lettone',
      mg: 'malgascio',
      mh: 'marshallese',
      mi: 'maori',
      mk: 'macedone',
      ml: 'malayalam',
      mn: 'mongolo',
      mr: 'marathi',
      ms: 'malese',
      mt: 'maltese',
      my: 'birmano',
      na: 'nauru',
      nb: 'norvegese bokmål',
      nd: 'ndebele del nord',
      ne: 'nepalese',
      ng: 'ndonga',
      nl: 'olandese',
      nn: 'norvegese nynorsk',
      no: 'norvegese',
      nr: 'ndebele del sud',
      nv: 'navajo',
      ny: 'nyanja',
      oc: 'occitano',
      oj: 'ojibwa',
      om: 'oromo',
      or: 'odia',
      os: 'ossetico',
      pa: 'punjabi',
      pi: 'pali',
      pl: 'polacco',
      ps: 'pashto',
      pt: 'portoghese',
      qu: 'quechua',
      rm: 'romancio',
      rn: 'rundi',
      ro: 'rumeno',
      ru: 'russo',
      rw: 'kinyarwanda',
      sa: 'sanscrito',
      sc: 'sardo',
      sd: 'sindhi',
      se: 'sami del nord',
      sg: 'sango',
      si: 'singalese',
      sk: 'slovacco',
      sl: 'sloveno',
      sm: 'samoano',
      sn: 'shona',
      so: 'somalo',
      sq: 'albanese',
      sr: 'serbo',
      ss: 'swati',
      st: 'sotho del sud',
      su: 'sundanese',
      sv: 'svedese',
      sw: 'swahili',
      ta: 'tamil',
      te: 'telugu',
      tg: 'tagico',
      th: 'thailandese',
      ti: 'tigrino',
      tk: 'turcomanno',
      tl: 'filippino',
      tn: 'tswana',
      to: 'tongano',
      tr: 'turco',
      ts: 'tsonga',
      tt: 'tataro',
      tw: 'akan',
      ty: 'taitiano',
      ug: 'uiguro',
      uk: 'ucraino',
      ur: 'urdu',
      uz: 'uzbeco',
      ve: 'venda',
      vi: 'vietnamita',
      vo: 'volapük',
      wa: 'vallone',
      wo: 'wolof',
      xh: 'xhosa',
      yi: 'yiddish',
      yo: 'yoruba',
      za: 'zhuang',
      zh: 'cinese',
      zu: 'zulu',
      at: 'tedesco',
      cz: 'ceco',
      'fr-FR': 'francese',
      'fr-BE': 'francese',
      'nl-BE': 'olandese'
    },
    colleague: 'collega',
    tradeInDate: 'data di permuta',
    vouchers: {
      id: 'ID',
      code: 'Codice',
      colleagueName: 'Nome collega',
      dealerName: 'Nome rivenditore',
      download: 'Download',
      points: 'Numero di punti per buono',
      amount: 'Numero di voucher',
      deleteConfirmTitle: 'Elimina voucher',
      deleteConfirmDescription: 'Sei sicuro di voler eliminare questo voucher?'
    },
    selectText: 'Selezionare',
    brochureCategories: {
      products: 'Prodotti',
      brand_and_solutions: 'Marchio e soluzioni',
      season_and_promotions: 'Stagione e promozioni',
      format: 'Formato',
      cars_and_vans: 'Auto e veicoli commerciali',
      truck_and_buses: 'Camion e autobus',
      motorcycle: 'Motocicletta',
      agriculture: 'Agricoltura',
      construction_machinery: 'Macchine da costruzione',
      bridgestone: 'Bridgestone',
      firestone: 'Firestone',
      bandag: 'Bandag',
      bleetcare: 'Fleetcare',
      webfleet: 'Webfleet',
      material: 'Materiali',
      brochures: 'Brochure',
      price_list: 'Listino prezzi',
      materials: 'Materiali',
      summer: 'Estate',
      winter: 'Inverno',
      all_season: 'Quattro stagioni',
      trucks: 'Camion',
      technology: 'Tecnologia',
      oe: 'OE',
      allSeason: 'Quattro stagioni',
      season: 'Stagione',
      promotions: 'Promozioni'
    },
    deleteMainBox: {
      title: 'Elimina la casella principale',
      description: 'Sei sicuro di voler eliminare questo elemento?'
    },
    apps: {
      app_new: 'Nuova app',
      title: 'Applicazioni',
      name: 'Nome',
      code: 'Codice',
      ownerName: 'Nome del proprietario',
      ownerEmail: 'E-mail del proprietario',
      firstName: 'Nome',
      lastName: 'Cognome',
      chooseFile: 'Scegli file',
      noFileSelected: 'Nessun file selezionato',
      tabDetails: 'Dettagli',
      tabBusinessUnits: 'Unità aziendali',
      tabLocalizedContent: 'Contenuti localizzati',
      tabOwners: "Proprietari dell'app",
      isVisibleEveryone: 'Accesso aperto',
      isSSOReady: 'SSO',
      relationDirect: 'Diretto',
      relationInDirect: 'Indiretto',
      clientType: 'Tipo cliente',
      clientTypeEveryone: 'Tutti',
      clientTypeDirect: 'Diretto',
      clientTypeIndirect: 'Indiretto',
      clientTypeDirectIndirect: 'Diretto + Indiretto',
      isVisibleEveryoneLabel:
        "Se attivo, l'accesso è aperto a tutti gli utenti che corrispondono alle impostazioni di visibilità sotto. Se disattivo, l'accesso è limitato e deve essere concesso manualmente per utente nel profilo utente o tramite caricamento di una lista utenti.",
      isSSOReadyLabel: 'SSO pronto?',
      relationDirectLabel: 'Clienti diretti',
      relationInDirectLabel: 'Clienti indiretti',
      removeOwner: 'Rimuovi',
      addNextOwner: 'Aggiungi proprietario successivo',
      saveOwners: 'Salva proprietari',
      local_app: 'App locale',
      managed_globally_info: "Questa applicazione è gestita dall'amministratore globale"
    },
    bsPlus: {
      onboarding: {
        title: "Benvenuto in Bridgestone <span class='text-danger'>PLUS</span>",
        termsAndConditions: 'Termini e condizioni',
        accept: 'Accetta',
        decline: 'Rifiuta',
        dataModal:
          'Per adattare questa offerta ai tuoi interessi, ti chiediamo di indicare brevemente i tuoi interessi di prodotto o le tue aree di attività.',
        scrollToAccept: 'Scorri verso il basso per accettare le nostre condizioni e continuare',
        welcomeMessage: 'Benvenuto in Bridgestone Plus',
        tailorOffer:
          'Per adattare questa offerta ai tuoi interessi, ti chiediamo di indicare brevemente i tuoi interessi di prodotto o le tue aree di attività.',
        bussinessType:
          'Per adattare questa offerta ai tuoi interessi, ti chiediamo di indicare brevemente i tuoi interessi di prodotto o le tue aree di attività.',
        selectAreas: 'Seleziona dalle seguenti aree',
        multipleAnswers: '(sono possibili risposte multiple):',
        personalPreferences: 'Preferenze personali',
        carTyres: 'Pneumatici auto, SUV e veicoli commerciali',
        motorcyclesTyres: 'Pneumatici moto',
        truckBusTyres: 'Pneumatici autocarri e autobus',
        agricultureTyres: 'Pneumatici per veicoli agricoli',
        otrTyres: 'Pneumatici OTR',
        save: 'Salva',
        businessRelationship: 'Qual è il tuo rapporto commerciale con Bridgestone?',
        selectRelationship: 'Seleziona*:',
        tradingPartner: 'Sono un partner commerciale che...',
        tradingPartnerDirect: '... ordina direttamente da Bridgestone',
        tradingPartnerIndirect: '... ordina indirettamente (ad es. tramite grossista)',
        tradingPartnerBoth: '... ordina sia direttamente che indirettamente',
        fleetResponsibleDirect: 'Sono un responsabile flotta che...',
        fleetResponsibleIndirect: '... ordina indirettamente (tramite commercio o grossista)',
        fleetResponsibleBoth: '... ordina direttamente e indirettamente',
        noBusinessRelationship: '<b>Non ho alcun rapporto commerciale con Bridgestone</b> (né diretto né indiretto)',
        yourCustomerNumber: 'Il tuo numero cliente Bridgestone*:',
        enterCustomerNumber: 'Inserisci il tuo numero cliente',
        waitPersonalisedView: 'Attendere un momento, la tua vista personalizzata di BRIDGESTONE PLUS è in fase di creazione.',
        personalised: 'PERSONALIZZATO',
        plusInfo: 'Qui trovi informazioni sul tuo account Plus e sulla tua casella Plus.',
        continue: 'Continua',
        skip: 'Salta',
        oneOfTwo: '1 di 2',
        openApps:
          'Puoi aprire direttamente le app a cui sei già registrato. Puoi anche richiedere l’accesso ad altre app che potrebbero essere rilevanti per te.',
        requiredFields: 'Compila i campi obbligatori: Titolo, Nome, Cognome',
        stage: 'Fase',
        chooseOne: '(Seleziona almeno una casella)',
        required: '*Campi obbligatori',
        lengthCsNumber: 'Lunghezza numero cliente: 6-10 cifre',
        waitForAdminApproval:
          'Grazie per esserti registrato al programma Bridgestone Plus Rewards. Stiamo esaminando la tua richiesta. Riceverai un’e-mail di conferma non appena la richiesta sarà approvata.',
        selectTyres: 'AREA DI ATTIVITÀ E PROFILO'
      }
    },
    anyLogin: 'qualsiasi accesso',
    frontend_menu: {
      account: 'Profilo',
      plus: 'Informazioni su Bridgestone Plus',
      salesSupport: 'Supporto vendite',
      mailbox: 'Casella di posta',
      about: 'Informazioni su Bridgestone Plus',
      trainingAndCourses: 'Formazioni online',
      externalTraining: 'Formazioni esterne',
      productInfo: 'Informazioni prodotto',
      productBrochures: 'Brochure',
      priceLists: 'Listino prezzi',
      price: 'Prezzo',
      complaintForm: 'Modulo di reclamo',
      sales_support: 'Supporto vendite',
      contact_service: 'Contatto & Servizio',
      logOut: 'Disconnetti',
      news: 'Feed notizie',
      news_feeds: 'Feed notizie',
      service_number: 'Contatto & Servizio',
      brochure_prices: 'Brochure e listino prezzi',
      trainings: 'Formazioni',
      salesPromotions: 'Promozioni vendite',
      stammdaten: 'Il mio profilo',
      onlineTrainings: 'Formazioni online',
      shop: 'Negozio',
      preislisten: 'Listino prezzi',
      medias: 'Media',
      media: 'Media',
      manageLinks: 'Gestisci link menu',
      noModuleLinksAvailable: 'Nessun link modulo disponibile per questo tenant.'
    },
    customerNumbersAssistant: {
      date: {
        title: 'Calcola i punti a partire dalla data X'
      },
      import: {
        openButton: 'Importa numeri cliente',
        loadingModal: 'Caricamento modal...',
        title: 'Importa i numeri cliente da Excel',
        validateButton: 'Valida file',
        submitButton: "Invia all'API",
        submitButtonLoading: 'Invio in corso...',
        selectWholesalerLabel: 'Grossista',
        selectGroupLabel: 'Gruppo',
        selectWholesalerPlaceholder: 'Seleziona grossista',
        selectGroupPlaceholder: 'Seleziona gruppo (opzionale)',
        requirementsTitle: 'Requisiti del file',
        fileFormatRequirement: 'Solo file Excel: .xlsx o .xls',
        headerRequirement: 'La riga di intestazione deve essere: Customer number, Email (colonne A/B).',
        createdLabel: 'Creati',
        alreadyExistsLabel: 'Già esistenti',
        success: 'Il file Excel è valido.',
        previewTitle: 'Anteprima',
        previewCount: '{count} righe, {pageSize} righe per pagina.',
        columnOne: 'Colonna 1',
        columnTwo: 'Colonna 2',
        previousPage: 'Precedente',
        nextPage: 'Successivo',
        pageInfo: 'Pagina {current} / {total}',
        progressLabel: 'Avanzamento',
        errors: {
          wholesalerRequired: 'Il grossista è obbligatorio.',
          groupRequired: 'Il gruppo è obbligatorio.',
          fileRequired: 'Il file Excel è obbligatorio.',
          emptyWorkbook: 'La cartella di lavoro Excel è vuota.',
          invalidHeaders: 'Il file deve contenere esattamente 2 colonne: numero cliente ed email.',
          emptyRows: 'Il file non contiene righe di dati.',
          firstTwoColumnsRequired: 'Riga {row}: la prima e la seconda colonna devono essere compilate.',
          invalidCustomerNumber: 'Numero cliente non valido alla riga {row}. Usa solo lettere e cifre.',
          invalidEmail: 'Email non valida alla riga {row}.',
          invalidFileType: 'Sono consentiti solo file Excel (.xlsx, .xls).',
          readError: 'Impossibile leggere il file Excel.',
          submitFailed: "Invio dei record all'API non riuscito."
        }
      }
    },
    product_sync: {
      syncEnabled: 'Sincronizzazione attivata',
      syncDisabled: 'Sincronizzazione disattivata',
      syncDisable: 'Aggiorna tramite API',
      syncEnable: 'Aggiornamento manuale del prodotto',
      notAvailableDisable: 'Non visibile nel negozio',
      notAvailableEnable: 'Visibile nel negozio',
      notAvailableDisabled: 'Non visibile nel negozio',
      notAvailableEnabled: 'Visibile nel negozio',
      notAvailableError: 'Errore: non disponibile',
      syncError: 'Errore di sincronizzazione',
      tooltip: {
        syncEnable:
          "Si noti che l'aggiornamento manuale del prodotto è limitato alla gestione di prezzo e punti. Tutte le altre informazioni sul prodotto verranno aggiornate tramite API e non possono essere modificate dall'amministratore locale.",
        notAvailableEnable: 'Segna il prodotto come non disponibile per questo mercato.',
        notAvailableDisable: 'Rendi il prodotto nuovamente disponibile per questo mercato.'
      }
    },
    category_sync: {
      syncEnabled: 'Sincronizzazione immagine attivata',
      syncDisabled: 'Sincronizzazione immagine disattivata',
      syncDisable: 'Aggiorna immagine tramite API',
      syncEnable: 'Aggiornamento manuale dell’immagine',
      syncError: 'Errore di sincronizzazione immagine',
      tooltip: {
        syncEnable:
          'La disattivazione della sincronizzazione riguarda solo l’immagine della categoria. Nome, descrizione e stato continuano a provenire dal catalogo globale. Finché la sincronizzazione dell’immagine è attiva, l’immagine viene presa dal catalogo globale e non può essere modificata localmente.'
      }
    },
    priceCategories: {
      pkw: 'Pkw, 4x4 e trasportatori',
      motorcycles: 'Motociclette',
      trucksAndBuses: 'Camion e autobus',
      agriculture: 'Agricoltura',
      constructionMachineryOtr: 'Macchine da cantiere OTR'
    },
    campaigns: {
      title: 'Campagne',
      new: 'Nuova campagna',
      edit: 'Modifica campagna',
      name: 'Nome campagna',
      subtitle: 'Sottotitolo campagna (opzionale)',
      description: 'Descrizione',
      type: 'Tipo di campagna',
      selectType: 'Seleziona tipo di campagna',
      periodName: 'Nome del periodo',
      startDate: 'Data di inizio',
      endDate: 'Data di fine',
      newPeriod: 'Nuovo periodo',
      image: 'Immagine',
      url: 'URL',
      active: 'Attivo',
      types: {
        'performance-speedy': 'Performance',
        'performance-cd': 'Performance CD',
        'booster-ccs': 'Booster CCS'
      },
      transferDealersModal: {
        openButton: "Trasferisci i rivenditori in un'altra campagna",
        title: 'Seleziona campagna',
        description: "Puoi trasferire i rivenditori dalla campagna corrente {campaignName} a un'altra.",
        loadingCampaigns: 'Caricamento campagne...',
        selectCampaignPlaceholder: 'Seleziona campagna',
        submit: 'Invia richiesta',
        sending: 'Invio in corso...',
        requestSent: 'Richiesta inviata',
        requestFailed: 'Invio della richiesta non riuscito'
      },
      alert: {
        title: 'Conferma',
        desc: 'Sei sicuro di voler rimuovere questa campagna?'
      }
    }
  },
  wholesaler_management: {
    modal: {
      description: 'Quali dati può vedere il grossista nei dettagli del rivenditore?'
    }
  },
  marketingConsents: {
    pageTitle: 'Consensi di marketing',
    title: 'Titolo',
    status: 'Stato',
    noConsents: 'Nessun consenso di marketing disponibile',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    enable: 'Abilita',
    disable: 'Disabilita',
    enableTitle: 'Abilita consenso di marketing',
    enableMessage: 'Sei sicuro di voler abilitare questo consenso di marketing?',
    disableTitle: 'Disabilita consenso di marketing',
    disableMessage: 'Sei sicuro di voler disabilitare questo consenso di marketing?',
    toggleSuccess: 'Lo stato del consenso di marketing è stato aggiornato con successo',
    toggleError: "Si è verificato un errore durante l'aggiornamento del consenso di marketing",
    consentType: 'Tipo di consenso',
    selectType: 'Seleziona tipo...',
    typeChanged: 'Tipo di consenso aggiornato con successo',
    typeChangeError: 'Impossibile aggiornare il tipo di consenso',
    visibleFrom: 'Visibile da',
    notYetVisible: 'Non ancora visibile',
    alwaysVisible: 'Sempre visibile'
  }
}
